import Image from "../../assets/img/homeSlider/Website-visual-2-55F9BEDl2-transformed.webp";

export default function HomeImage() {
  return <img src={Image} alt="Donate to Gateway Industry" />;
}
